"use client";

import { trpcApi } from "@lattice/frontend/lib/trpc/client/index";
import { useAtomValue } from "jotai";
import { interval_atom } from "@lattice/frontend/components/charts/chart-atoms";
import { Skeleton } from "@lattice/frontend/components/ui/skeleton";
import NonDraggableStockPriceChart from "@lattice/frontend/components/charts/non-draggable-stock-price-chart";

export default function StockPriceChartSection({
  stock_symbol,
  is_crypto,
}: {
  stock_symbol: string;
  is_crypto: boolean;
}) {
  const interval = useAtomValue(interval_atom);

  const { data: price, isPending } =
    trpcApi.stock.get_historical_price_all.useQuery({
      symbol: stock_symbol,
      is_crypto,
    });

  const latest_price = price?.[interval]?.at(-1);
  const first_price = price?.[interval]?.at(0);

  return (
    <div className="w-full">
      {/* Separator Line */}
      <div className="w-full h-px bg-border/50 mb-4" />

      {/* Price and Actions Row */}
      <div className="w-full bg-background flex flex-col justify-end">
        {latest_price && first_price ? (
          <div className="flex justify-between items-center gap-4 pb-2">
            <div className="min-w-fit py-2">
              <div className="flex items-baseline gap-2.5">
                <p className="font-bold text-3xl lg:text-5xl text-white/90">
                  ${latest_price.c.toFixed(2)}
                </p>
                <p
                  className={`font-semibold text-lg ${
                    latest_price.c > first_price.c
                      ? "text-[rgb(0,200,5)]"
                      : "text-[rgb(255,80,0)]"
                  }`}
                >
                  {latest_price.c > first_price.c ? "+" : ""}
                  {(latest_price.c - first_price.c).toFixed(2)} (
                  {latest_price.c > first_price.c ? "+" : ""}
                  {(
                    ((latest_price.c - first_price.c) / first_price.c) *
                    100
                  ).toFixed(2)}
                  %)
                </p>
              </div>
            </div>
          </div>
        ) : isPending ? (
          <div className="flex justify-between items-center gap-4 pb-2">
            <div className="min-w-fit px-4 py-2 rounded-lg">
              <div className="flex items-baseline gap-2.5">
                <Skeleton className="h-12 w-48 rounded-md" />
                <Skeleton className="h-6 w-32 rounded-md" />
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {/* Chart */}
      <div className="w-full">
        <NonDraggableStockPriceChart
          symbol={stock_symbol}
          is_crypto={is_crypto}
        />
      </div>
    </div>
  );
}
